var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckBold = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382-221.912L135.912-468l75.653-75.653L382-373.218l366.435-366.435L824.088-664z"
  })));
};
export default SvgCheckBold;